import Component from "@lib/Component.js";
import { addClass, removeClass } from "@qneyraud/q-utils";

export default class Debug extends Component {
  onEnterCompleted() {
    super.onEnterCompleted();

    const urlParams = new window.URLSearchParams(window.location.search);

    const hasDebug = urlParams.has("debug");

    if (hasDebug) {
      addClass(this.el, "shown");
    } else {
      removeClass(this.el, "shown");
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Debug.js